import ActivityRecurringUnit from "@mapmycustomers/shared/enum/activity/ActivityRecurringUnit";

import IntervalUnit from "@app/enum/IntervalUnit";
import RecurringIntervalType from "@app/enum/RecurringIntervalType";
import RecurInterval from "@app/types/activity/RecurInterval";

interface IsAnnualIntervalParams {
  recurInterval?: RecurInterval;
  recurIntervalType?: RecurringIntervalType;
}

const isAnnualInterval = ({ recurInterval, recurIntervalType }: IsAnnualIntervalParams) =>
  recurIntervalType === RecurringIntervalType.CUSTOM &&
  (recurInterval?.unit === IntervalUnit.YEAR ||
    (recurInterval?.unit === ActivityRecurringUnit.MONTH && recurInterval?.value === 12));

export default isAnnualInterval;
